import React from "react";

import workPassportControlledImplementationFiveStagePathDesktop from "../../images/work-passport-controlled-implementation-five-stage-path-desktop.svg";
import workPassportControlledImplementationFiveStagePathMobile from "../../images/work-passport-controlled-implementation-five-stage-path-mobile.svg";

import "./WorkPassportControlledImplementation.css";

export default function WorkPassportControlledImplementation() {
  return (
    <section
      className="work-passport-controlled-implementation"
      id="work-passport-controlled-implementation"
      aria-labelledby="work-passport-controlled-implementation-title"
    >
      <div className="work-passport-controlled-implementation__shell">
        <header className="work-passport-controlled-implementation__header">
          <p className="work-passport-controlled-implementation__kicker">
            A controlled implementation
          </p>
          <h2 id="work-passport-controlled-implementation-title">
            From scattered records to{" "}
            <em>live workforce readiness.</em>
          </h2>
          <p>
            A credible implementation begins with governed requirements,
            validated outcomes and a controlled move into automation.
          </p>
        </header>

        <picture className="work-passport-controlled-implementation__path">
          <source
            media="(max-width: 620px)"
            srcSet={workPassportControlledImplementationFiveStagePathMobile}
          />
          <img
            src={workPassportControlledImplementationFiveStagePathDesktop}
            alt="Discover, configure, import, validate and automate implementation path"
            loading="lazy"
          />
        </picture>
      </div>
    </section>
  );
}
